<template>
  <!-- 注册 -->
  <div class="register">
    <home-nav></home-nav>
    <register-phone></register-phone>
    <register-footer></register-footer>
  </div>
</template>

<script>
import HomeNav from '../common/Nav.vue';
import RegisterPhone from './components/Phone.vue';
import RegisterFooter from '../common/Footer.vue';

export default {
  name: 'Register',
  props: {
  },
  data() {
    return {
    }
  },
  components: {
    HomeNav,
    RegisterFooter,
    RegisterPhone
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
